import React from 'react'
import { useNavigate } from 'react-router-dom'

import CreateIcpCard from '@/modules/icp/components/CreateIcpCard/CreateIcpCard'
import CreatePersonMemoTaskCard from '@/modules/task/components/CreatePersonMemoTaskCard/CreatePersonMemoTaskCard'
import CreateTranscriptReportTaskCard from '@/modules/task/components/CreateTranscriptReportTaskCard/CreateTranscriptReportTaskCard'
import { AnyTask } from '@/modules/task/model'

const PlaygroundPage: React.FC = () => {
  const navigate = useNavigate()
  const handleTaskCreated = (task: AnyTask) => {
    navigate(`/playground/t/${task.id}`)
  }

  return (
    <div className="m-auto w-full max-w-3xl px-6 pb-8 pt-8">
      <h1 className="mb-4 font-semibold">Create a new task</h1>

      <div className="flex flex-col gap-6">
        <CreatePersonMemoTaskCard onTaskCreated={handleTaskCreated} isAnon />
        <CreateTranscriptReportTaskCard onTaskCreated={handleTaskCreated} isAnon />
        <CreateIcpCard onIcpCreated={() => {}} isAnon />
      </div>
    </div>
  )
}

export default PlaygroundPage
